import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2caf1b1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mb-4" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Voltar", -1))
const _hoisted_5 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7" }
const _hoisted_6 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 radius-7" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "mb-0" }, "Usuários")
], -1))
const _hoisted_8 = {
  key: 0,
  class: "d-sm-flex align-items-center"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none ms-0",
  href: "#",
  "data-bs-toggle": "modal",
  "data-bs-target": "#CreateUserModal"
}, [
  /*#__PURE__*/_createTextVNode(" Criar novo usuário "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user-1 position-relative ms-5 fs-14" })
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "card-body p-15 p-sm-20 p-md-25 mt-10" }
const _hoisted_12 = { class: "table-responsive" }
const _hoisted_13 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " Nome "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Celular "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Telefone comercial "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " email "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " status "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    }, " Ativar / Inativar ")
  ])
], -1))
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-center pe-0 d-flex justify-content-end" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeleteUserModal = _resolveComponent("DeleteUserModal")!
  const _component_CreateUserModal = _resolveComponent("CreateUserModal")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DeleteUserModal),
    _createVNode(_component_CreateUserModal),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/installation",
          class: "text-decoration-none d-flex font-14 me-3 text-black"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _hoisted_4
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        (_ctx.getConfigurations.adm)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("table", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUsersForCompanyId, (value, key) => {
                return (_openBlock(), _createElementBlock("tr", { key: key }, [
                  _createElementVNode("th", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(value.name), 1)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.applyMaskPhone(value.cell_phone)), 1),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.applyMaskPhone(value.commercial_phone)), 1),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(value.email), 1),
                  _createElementVNode("td", {
                    class: _normalizeClass([{'active-column': value.active, 'inactive-column': !value.active}, "shadow-none lh-1 fw-medium text-black-emphasis"])
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass([{'ph ph-x-circle': !value.active, 'ph ph-check-circle': value.active}, "lh-1 position-relative top-1 fs-16"])
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(value.active == 1 ? 'Ativo' : 'Inativo'), 1)
                  ], 2),
                  _createElementVNode("td", _hoisted_21, [
                    _createElementVNode("button", {
                      class: _normalizeClass([{'inactive': value.active, 'active': !value.active}, "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"]),
                      onClick: ($event: any) => (_ctx.setCurrentDeleteUser(value)),
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#DeleteUserModal",
                      type: "button"
                    }, [
                      (value.active)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Inativar"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_24, "Ativar"))
                    ], 10, _hoisted_22)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}